import InteractionForm from './InteractionForm'

export default InteractionForm
